<script lang="ts">
	import { productName } from '$lib/paraglide/messages';

	import Feature from './feature.svelte';
	import chatDark from './shots/chat-dark.png';
	import chatLight from './shots/chat-light.png';
	import exportDark from './shots/export-dark.png';
	import exportLight from './shots/export-light.png';
	import promptsDark from './shots/prompts-dark.png';
	import promptsLight from './shots/prompts-light.png';
	import providersDark from './shots/providers-dark.png';
	import providersLight from './shots/providers-light.png';
	import settingsDark from './shots/settings-dark.png';
	import settingsLight from './shots/settings-light.png';
	import storageDark from './shots/storage-dark.png';
	import storageLight from './shots/storage-light.png';
</script>

<ul class="max-w-xl mx-auto prose flex flex-col gap-3 sm:gap-0">
	<li>
		<Feature imageDark={chatDark} imageLight={chatLight}>
			<p>A simple but powerful interface. Adapts to your screen real estate.</p>
		</Feature>
	</li>

	<li>
		<Feature flip imageDark={storageDark} imageLight={storageLight}>
			<p>
				{productName()} stores your data <em>securely on your device</em> using
				<a
					href="https://developer.mozilla.org/en-US/docs/Web/API/File_System_API/Origin_private_file_system"
					target="_blank">modern web tech</a
				>. No privacy headaches!
			</p>
		</Feature>
	</li>

	<li>
		<Feature imageDark={providersDark} imageLight={providersLight}>
			<p>Use all the LLM providers, even your own. Pay the price you are willing to pay.</p>
		</Feature>
	</li>

	<li>
		<Feature flip imageDark={settingsDark} imageLight={settingsLight}>
			<p>Stay in control. Fine-tune inference parameters and keep an eye on cost.</p>
		</Feature>
	</li>

	<li>
		<Feature imageDark={promptsDark} imageLight={promptsLight}>
			<p>Use the power of system prompts to make the LLMs behave the way <i>you</i> want.</p>
		</Feature>
	</li>

	<li>
		<Feature imageDark={exportDark} imageLight={exportLight} flip>
			<p>Your data &mdash; Your rules.</p>
		</Feature>
	</li>
</ul>
